import React from 'react';
import { Box, Button, Heading, Text } from '@wix/design-system';
import classNames from 'classnames';
import s from './MobileAnonymousHeader.scss';
export const MobileAnonymousHeader = ({ onCtaClick, title, subtitle, ctaText, classNames: styling, }) => {
    return (React.createElement(Box, { background: "white", width: "100%" },
        React.createElement(Box, { width: "80%", direction: "vertical", textAlign: "center", align: "center", margin: "30px auto", gap: "SP1" },
            React.createElement(Heading, { appearance: "H1", className: classNames(s.title, styling?.title) }, title),
            React.createElement(Text, { size: "small", className: styling?.subtitle }, subtitle),
            React.createElement(Box, { marginTop: "SP2" },
                React.createElement(Button, { skin: "premium", fullWidth: false, onClick: onCtaClick, className: styling?.cta }, ctaText)))));
};
//# sourceMappingURL=MobileAnonymousHeader.js.map